<span class="toggle-label"></span>
<mat-button-toggle-group [(ngModel)]="direction" (ngModelChange)="onDirectionChange($event)" [disabled]="disabled">
  <mat-button-toggle value="right">
    <!-- <mat-icon class="toggle-icon">arrow_forward</mat-icon> -->
    <span>Tab向右</span>
    <mat-icon class="toggle-icon">arrow_forward</mat-icon>
  </mat-button-toggle>
  <mat-button-toggle value="down">
    <!-- <mat-icon class="toggle-icon">arrow_downward</mat-icon> -->
    <span>Tab向下</span>
    <mat-icon class="toggle-icon">arrow_downward</mat-icon>
  </mat-button-toggle>
</mat-button-toggle-group>
